// extracted by mini-css-extract-plugin
export default {"About":"About_About__aRQVR","AboutDark":"About_AboutDark__Y4QHX","mailSvg":"About_mailSvg__HNJqH","email":"About_email__qDHhM"};